// Must match backend IAP_PROMO_ALLOWED_PERCENTS: stream discounts are sold as
// cheaper store products, and only these percents have one.
export const STREAM_DISCOUNT_PERCENTS: readonly number[] = [
  1, 5, 10, 20, 30, 40, 50, 100,
];

export const STREAM_DISCOUNT_OPTIONS = STREAM_DISCOUNT_PERCENTS.map(
  (percent) => ({ value: percent, label: `${percent}%` })
);

export const isStreamDiscountAllowed = (amount?: number | null): boolean =>
  amount != null && STREAM_DISCOUNT_PERCENTS.includes(Number(amount));

export const amountFormatter = (value?: string | number): string =>
  value ? `${value}%` : '';

export const amountParser = (value?: string): string | number =>
  value?.replace('%', '') || 0;
